import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

function Breadcrumb({ items }) {
  return (
    <nav className="bg-white border-b border-gray-200 py-3">
      <div className="container mx-auto px-4">
        <ol className="flex items-center space-x-2 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronRight size={16} className="text-gray-400 mx-2" />
              )}
              {item.link ? (
                <Link
                  to={item.link}
                  className="text-gray-600 hover:text-[#2AA8B0] transition-colors font-medium"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-[#2AA8B0] font-semibold">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}

export default Breadcrumb;